import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Save, Send } from "lucide-react";
import { Section, Field, Header } from "./TextsTab";

export default function SmtpTab() {
  const [cfg, setCfg] = useState({
    host: "", port: 587, encryption: "starttls",
    user: "", password: "",
    from_email: "", from_name: "LUVA Solutions",
    to_email: "",
  });
  const [saving, setSaving]   = useState(false);
  const [testing, setTesting] = useState(false);

  useEffect(() => {
    api.get("/admin/smtp-config").then(r => setCfg(c => ({ ...c, ...r.data }))).catch(() => {});
  }, []);

  const saveCfg = async () => {
    setSaving(true);
    try {
      await api.post("/admin/smtp-config", cfg);
      toast.success("Configuración SMTP guardada");
    } catch {
      toast.error("Error al guardar la configuración");
    } finally { setSaving(false); }
  };

  const testSmtp = async () => {
    setTesting(true);
    try {
      const { data } = await api.post("/admin/smtp-test");
      toast.success(data.message);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No se pudo enviar el correo de prueba");
    } finally { setTesting(false); }
  };

  return (
    <div className="space-y-8 max-w-3xl">
      <Header
        title="Email (SMTP)"
        subtitle="Configurá el correo saliente para recibir un aviso cada vez que alguien complete el formulario de contacto de la web."
      />

      <Section title="Servidor SMTP">
        <div className="grid sm:grid-cols-2 gap-3">
          <Field label="Host SMTP (ej: mail.tudominio.com)" value={cfg.host} onChange={v => setCfg(c => ({ ...c, host: v }))} />
          <Field label="Puerto" value={String(cfg.port)} onChange={v => setCfg(c => ({ ...c, port: Number(v) || 587 }))} />
        </div>
        <div>
          <label className="block text-xs text-[#9bb0e0] mb-1.5">Seguridad</label>
          <select
            value={cfg.encryption}
            onChange={e => setCfg(c => ({ ...c, encryption: e.target.value }))}
            className="w-full bg-[rgba(10,20,55,0.5)] border border-[rgba(120,160,255,0.18)] rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:border-[#5fa0ff]"
          >
            <option value="starttls">STARTTLS (recomendado — puerto 587)</option>
            <option value="ssl">SSL/TLS implícito (puerto 465)</option>
            <option value="none">Sin cifrado</option>
          </select>
        </div>
        <Field label="Usuario SMTP" value={cfg.user} onChange={v => setCfg(c => ({ ...c, user: v }))} />
        <div>
          <label className="block text-xs text-[#9bb0e0] mb-1.5">Contraseña</label>
          <input
            type="password"
            value={cfg.password}
            onChange={e => setCfg(c => ({ ...c, password: e.target.value }))}
            className="w-full bg-[rgba(10,20,55,0.5)] border border-[rgba(120,160,255,0.18)] rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:border-[#5fa0ff]"
          />
        </div>
      </Section>

      <Section title="Remitente y destino">
        <div className="grid sm:grid-cols-2 gap-3">
          <Field label="Email remitente (ej: web@tudominio.com)" value={cfg.from_email} onChange={v => setCfg(c => ({ ...c, from_email: v }))} />
          <Field label="Nombre del remitente" value={cfg.from_name} onChange={v => setCfg(c => ({ ...c, from_name: v }))} />
        </div>
        <Field label="Email donde recibís los avisos de contacto" value={cfg.to_email} onChange={v => setCfg(c => ({ ...c, to_email: v }))} />

        <div className="flex gap-3 flex-wrap pt-2">
          <button onClick={saveCfg} disabled={saving} className="btn-primary px-5 py-2.5 rounded-lg inline-flex items-center gap-2 text-sm font-medium">
            <Save className="w-4 h-4" /> {saving ? "Guardando…" : "Guardar configuración"}
          </button>
          <button onClick={testSmtp} disabled={testing || !cfg.host || !cfg.to_email} className="btn-line px-5 py-2.5 rounded-lg inline-flex items-center gap-2 text-sm font-medium disabled:opacity-50">
            <Send className="w-4 h-4" /> {testing ? "Enviando…" : "Enviar correo de prueba"}
          </button>
        </div>
        {(!cfg.host || !cfg.to_email) && (
          <p className="text-[#7da3ff] text-[11px]">Completá host y destinatario para poder probar.</p>
        )}
      </Section>
    </div>
  );
}
